import React, { useEffect, useMemo, useRef, useState } from "react";
import BtnSlider from "../../../components/Slider/BtnSlider";
import { URL_S3 } from "../../../config/BaseUrl";
import GalleryMediaStats from "./GalleryMediaStats";
import useGalleryMediaDetails from "./useGalleryMediaDetails";

const getValidSlideIndex = (index, itemCount) => {
  const parsedIndex = Number(index);

  return Number.isInteger(parsedIndex) && parsedIndex >= 0 && parsedIndex < itemCount
    ? parsedIndex
    : 0;
};

const getMediaFileName = (item, fileKey, initialDetails) => {
  if (item?.[fileKey]) return item[fileKey];

  const fallbackKeys = [
    fileKey,
    "video_url",
    "boomerang_url",
    "event_gif",
    "event_burst_gif",
    "event_video",
  ];

  return fallbackKeys.map((key) => initialDetails?.[key]).find(Boolean);
};

const GalleryVideoDetailsPlayer = ({
  activeItemIndex = 0,
  dataSlider = [],
  directory,
  fileKey,
  initialDetails,
  title,
}) => {
  const initialSlideIndex = getValidSlideIndex(activeItemIndex, dataSlider.length);
  const [slideIndex, setSlideIndex] = useState(initialSlideIndex);
  const videoRef = useRef(null);
  const activeItem = dataSlider[slideIndex];
  const { loading, media } = useGalleryMediaDetails(activeItem?.id, initialDetails);
  const mediaUrl = useMemo(() => {
    const fileName = getMediaFileName(activeItem, fileKey, initialDetails);

    return fileName
      ? `${URL_S3}event_gallery/${directory}/${fileName}`
      : "";
  }, [activeItem, directory, fileKey, initialDetails]);

  useEffect(() => {
    setSlideIndex(getValidSlideIndex(activeItemIndex, dataSlider.length));
  }, [activeItemIndex, dataSlider.length]);

  useEffect(() => {
    const video = videoRef.current;

    if (!video || !mediaUrl) return;

    video.load();
    const playRequest = video.play();

    if (playRequest?.catch) {
      playRequest.catch(() => {
        // Browsers can block unmuted autoplay; the visible controls still allow playback.
      });
    }
  }, [mediaUrl]);

  const nextSlide = () => setSlideIndex((current) => current + 1 === dataSlider.length ? 0 : current + 1);
  const prevSlide = () => setSlideIndex((current) => current === 0 ? dataSlider.length - 1 : current - 1);

  return (
    <>
      <div className="full_screen_left">
        <div className="container-slider">
          {activeItem && mediaUrl ? (
            <div className="slide active-anim">
              <video
                ref={videoRef}
                key={`${activeItem.id}-${mediaUrl}`}
                autoPlay
                controls
                playsInline
                preload="auto"
                src={mediaUrl}
              >
                Your browser does not support video playback.
              </video>
            </div>
          ) : (
            <div className="gallery-media-unavailable">Media file is unavailable.</div>
          )}
          {dataSlider.length > 1 ? <BtnSlider moveSlide={nextSlide} direction="next" /> : null}
          {dataSlider.length > 1 ? <BtnSlider moveSlide={prevSlide} direction="prev" /> : null}
        </div>
      </div>
      <aside className="full_screen_right">
        <GalleryMediaStats loading={loading} media={media} title={title} />
      </aside>
    </>
  );
};

export default GalleryVideoDetailsPlayer;
